import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { intlReducer as intl } from 'react-intl-redux';
import locales from '@whitelabel/reducers/locales';
import user from './user';
import customer from './customer';
import navs from './navs';
import pages from './pages';
import pageSegments from './pageSegments';
import help from './help';
import bookings from './bookings';
import claimBookings from './claimBookings';
import coi from './coi';
import pds from './pds';
import claims from './claims';
import claimQuestions from './claimQuestions';
import quotes from './quotes';
import partners from './partners';
import feMessages from './intl';

const createRootReducer = (history: any) =>
  combineReducers({
    router: connectRouter(history),
    intl,
    locales,
    user,
    customer,
    navs,
    pages,
    pageSegments,
    help,
    bookings,
    claimBookings,
    coi,
    pds,
    claims,
    claimQuestions,
    quotes,
    partners,
    feMessages,
  });

export default createRootReducer;
